import React, { FC, useState } from "react";
import { RouterParamType } from "@/model/navModel";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { SystemFormBox } from "./SystemFormBox";


export const BaseDetail: FC<RouterParamType> = (detailsInfo) => {

    return (
        <>
            <FormBox {...detailsInfo} />
            {/* <TableBox {...detailsInfo} /> */}
            <SystemFormBox {...detailsInfo} />
        </>

    )
}